module.exports = __webpack_public_path__ + "static/media/intake-follow-up-and-outcomes-questionnaires-02@3x.775e1aba.png";